// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-de81a708]{padding-left:2rem;text-align:center}", "",{"version":3,"sources":["webpack://./resources/frontend/js/components/common/form/TextInputLicensePlate.vue"],"names":[],"mappings":"AACA,uBACE,iBAAA,CACA,iBAAF","sourcesContent":["\ninput {\n  padding-left: 2rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
